import { Component, OnInit, Input,ViewChild, OnChanges, ChangeDetectorRef, ElementRef, EventEmitter , Output, ComponentFactoryResolver, ViewContainerRef, ComponentRef, TemplateRef, ComponentFactory, AfterViewInit, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import { FormBuilder ,UntypedFormGroup} from '@angular/forms';
import { DynamicFormsService } from '../../services/dynamic-forms.service';
import { DynamicFormsComponent } from './../dynamic-forms.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { columnsDef } from 'src/app/interfaces/columnsDef';



@Component({
    selector: 'app-form-view',
    templateUrl: './form-view.component.html',
    styleUrls: ['./form-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})



export class FormViewComponent implements OnInit, OnChanges, AfterViewInit  {

  
  @Input("row") row:Object;
  @Input("arrayColumnsDef") arrayColumnsDef:columnsDef[];
  @Input("rowTemplate") rowTemplate:columnsDef[];
  @Input("service") dynaServices:DynamicFormsService;
  @Input("fatherFilterExpression") fatherFilterExpression:string;
  public dynamicForm:UntypedFormGroup;
  @Output() submitted: EventEmitter<any> = new EventEmitter();
  public component:ComponentRef<any>;
  @ViewChild('dynamic', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef
  selectedTabIndex: number = 0;
  @Input("tabs") tabs:String[];
  @ViewChild('childform',{read:DynamicFormsComponent}) childform:DynamicFormsComponent;
  private stop:boolean = false;
  private leaving:number = -1;
  public fatherData:object;

  constructor(  private resolver: ComponentFactoryResolver,private container: ViewContainerRef, private cd: ChangeDetectorRef) {

  }


  getRowTemplate(type:string):columnsDef[]{
    if ( this.rowTemplate!= null && this.rowTemplate.length > 0){
      if ( type == "PK"){
        return this.rowTemplate.filter(x=>{return x != null ? x.ISPK == 1 : false});
      }else{
        return this.rowTemplate.filter(x=>{return  x != null ? x.ISPK != 1 : false});
      }
  
    }
    
  }

  addTab(tab:String){
    
  }
  
  ngOnInit() {
    //this.tabGroup._handleClick = this.interceptTabChange.bind(this);
    
    this.onChange();
    this.tabs = this.dynaServices.tabs;

    if ( ObjectUtil.isNotEmpty(this.row)){
      this.fatherData = this.gettingPk(this.row);
    }
    

    if ( this.dynaServices.selectedRow.length > 0 || this.row != null ){
      if ( this.childform != null && this.childform._dynaServices != undefined && this.childform._dynaServices != null ){
        this.childform._dynaServices.childFilterExpression = this.dynaServices.selectedRow[0]["filterExpression"];
        this.childform._dynaServices.fetch(0,false,false);
      }
    }
  }

  refreshChild(id){
    this.leaving = id; 
   
  }

  dont(event){

  }

  ngOnChanges():void{

  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.selectedTabIndex = 1;
      this.cd.markForCheck();
    });
  }


  gettingPk(row):object{
  
    let pkCol:string[] = [];

    this.rowTemplate.forEach(x=>{
      if ( x.ISPK === 1){
          let columnName:string = x.COLUMNNAME;
          pkCol.push(columnName);
      }
    });

    var obKey = {};

    pkCol.forEach(x =>{
       obKey[x] = row[x];
    });
   
    return obKey;
  }
  
  
  onChange(){
    this.dynaServices.refreshForm(null,this.row);
    this.dynamicForm = this.dynaServices.dynamicForm;
    
  }
 
  valeu:any;

  
}